// copied from Willy

import React from "react";
import PropTypes from "prop-types";
import { Dropdown, DropdownItemIcons, Icon } from "@weezevent/nacre";
import css from "./sortButton.module.scss";

function SortButton({ options, active, sortValue, label, sort, onChange }) {
	return (
		<>
			<Dropdown
				onClick={onChange}
				closeOnDocumentClick
				inverted
				className={!active && css["inactive"]}
				label={
					<>
						<Icon name="sort" size="regular" />
						<span>{label}</span>
					</>
				}
				primary
				size="maxi"
				type="button"
			>
				{options.map(item => {
					return (
						<DropdownItemIcons
							checked={sortValue === item.value}
							key={item.key}
							item={item.value}
							onClick={() => sort(item.value)}
						>
							{item.label}
						</DropdownItemIcons>
					);
				})}
			</Dropdown>
		</>
	);
}

SortButton.propTypes = {
	active: PropTypes.bool.isRequired,
	label: PropTypes.node,
	onChange: PropTypes.func.isRequired,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			key: PropTypes.string.isRequired
		})
	).isRequired,
	sortValue: PropTypes.string.isRequired,
	sort: PropTypes.func.isRequired
};

SortButton.defaultProps = {
	label: "sort"
};

export default SortButton;
